import React, { useEffect, useState } from 'react';
import { App, Tabs, Flex, Space, Button } from 'antd';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import { useDeleteShopMutation } from '../service/shops';
import getEnvConfig from '../../../../../utils/config/env';
import { ShopCard } from '../components/ShopCard';
import { getTabs } from '../utils/tabs';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../store/shopSlice';
import { ConfirmationDialog } from '../../../../../shared/ui/ConfirmationDialog';
import { ShopEditContainer } from './ShopEditContainer';

export const ShopContainer = () => {
    const { notification } = App.useApp();
    const location = useLocation();
    const navigate = useNavigate();

    const [open, setOpen] = useState(false);

    const current = useAppSelector(selectShopCurrent);

    const [deleteShop, { isSuccess }] = useDeleteShopMutation();

    useEffect(() => {
        if (isSuccess) {
            navigate(`${getEnvConfig().PUBLIC_PATH}/shops`);
            notification.success({
                message: 'Магазин успешно удален',
            });
        }
    }, [isSuccess]);

    const onChange = (key: string) => {
        navigate(`${getEnvConfig().PUBLIC_PATH}/shops/shop/${key}`);
    };

    const handleEditShop = () => {
        setOpen(true);
    };

    const activeTabKey =
        getTabs().find(t => location.pathname.includes(t.key))?.key ||
        getTabs()[0].key;

    const Actions = () => {
        return (
            <Space align={'center'} direction={'horizontal'} wrap>
                <ConfirmationDialog
                    activator={
                        <StyledButton>
                            <DeleteOutlined />
                        </StyledButton>
                    }
                    onConfirm={() => deleteShop(current.id)}
                    title='Удалить магазин?'
                    description={`Внимание! Восстановить магазин ${current?.name} после удаления будет невозможно. `}
                    withCheckbox
                />
                <StyledButton onClick={handleEditShop}>
                    <EditOutlined />
                </StyledButton>
            </Space>
        );
    };

    if (!current) return;

    return (
        <Flex vertical gap={24}>
            <ShopCard loading={!current} shop={current} actions={<Actions />} />
            <Tabs
                activeKey={activeTabKey}
                items={getTabs(current.type === 1 || current.type === 2).filter(
                    item => !item.disabled
                )}
                onChange={onChange}
            />
            {open && <ShopEditContainer open={open} setOpen={setOpen} />}
            <Outlet />
        </Flex>
    );
};

const StyledButton = styled(Button)`
    padding: 0 0.5rem;
`;
